/* eslint-disable no-restricted-imports */
export * from 'react-bootstrap';

import OverlayTrigger from 'components/bootstrap_overlay_trigger';

export {OverlayTrigger};
